const handleTimestamp = (timestamp) => {
  const strTimestamp = timestamp.toString()
  if (strTimestamp.length === 10) {
    return +strTimestamp * 1000
  } else if (strTimestamp.length === 13) {
    return +strTimestamp
  } else {
    return new Error('时间戳错误')
  }
}

export default handleTimestamp
